<template>
  <div class="grid-container-usage-examples" id="identidade-visual-cores-aplicacoes" data-search-anchor>
    <div class="logo-title-usage-examples-wrapper">
      <h1 class="logo-usage-examples-title-span">{{ logoUsageExamplesAplicacaoTitleSpan }}</h1>
      <h1 class="logo-usage-examples-title">{{ logoUsageExamplesAplicacaoTitle }}</h1>
    </div>
    <div class="grid-usage-examples-image" :style="{ backgroundImage: `url(${ImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import ColorPageMixin from '@/mixins/color-page-mixin'
import { ColorPageStore } from '@/store/visual-identity-page/color-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class ColorsGridUsageExamplesSection extends Mixins(ColorPageMixin) {
  colorPageStore: PageStoreContract = getModule(ColorPageStore, this.$store)

  get ImageSrc(): string {
    return this.getElementMedia(8, 0)
  }

  get logoUsageExamplesAplicacaoTitleSpan(): string {
    return this.getElementTitle(8, 0)
  }

  get logoUsageExamplesAplicacaoTitle(): string {
    return this.getElementText(8, 0)
  }

  async getColorPage(): Promise<void> {
    await this.colorPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.colorPageStore.isLoading) {
      await this.getColorPage()
    }
  }
}
</script>

<style lang="scss">
.grid-container-usage-examples {
  display: grid;
  max-width: 1032px;
  width: 100%;
}

.logo-title-usage-examples-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.logo-usage-examples-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-usage-examples-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.grid-usage-examples-image {
  position: relative;
  left: 0;
  max-width: 1032px;
  width: 100%;
  height: 533px;  
  margin-bottom: 2rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
